"use client";

import styles from "./SignUpHeroBanner.module.scss";

import { useTranslations } from "@/i18n";
import { Flex } from "@vetty/ui";

/**
 * SignUpHeroBanner Component
 *
 * Desktop marketing banner with value propositions and feature highlights.
 * Only visible on desktop/laptop screens to promote the platform benefits.
 */
export const SignUpHeroBanner = () => {
  // Translations
  const t = useTranslations("signUp.heroBanner");

  // Marketing feature points displayed on desktop
  const POINTS = [
    {
      id: "quick-setup",
      label: t("features.quickSetup"),
      iconUrl: "/assets/clock-icon.svg",
      iconAlt: "Clock icon - Quick setup",
    },
    {
      id: "free-trial",
      label: t("features.freeTrial"),
      iconUrl: "/assets/tag-icon.svg",
      iconAlt: "Tag icon - Free trial",
    },
    {
      id: "flexible-cancellation",
      label: t("features.flexibleCancellation"),
      iconUrl: "/assets/card-icon.svg",
      iconAlt: "Card icon - Payment information",
    },
  ];

  return (
    <div className={styles["comp"]}>
      {/* Main headline with call-to-action */}
      <h1
        className={styles["comp__header"]}
        dangerouslySetInnerHTML={{ __html: t.raw("title") }}
      />

      {/* Feature points list */}
      <Flex direction={"column"} gap={20} className={styles["comp__features"]}>
        {POINTS.map((p) => (
          <Flex
            key={p.id}
            align={"center"}
            gap={12}
            className={styles["comp__features__item"]}
          >
            {/* Feature icon */}
            <img
              className={styles["comp__features__item__icon"]}
              src={p.iconUrl}
              alt={p.iconAlt}
            />

            {/* Feature description */}
            <div
              className={styles["comp__features__item__label"]}
              dangerouslySetInnerHTML={{ __html: p.label }}
            />
          </Flex>
        ))}
      </Flex>
    </div>
  );
};
